import { Skeleton } from "pepsico-ds";

const SkeletonList = ({ count = 1, height=15 }) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {Array.from({ length: count }).map((_, index) => (
          <Skeleton 
            key={index}
            height={height+"px"} 
            width="100%" 
          />
        ))}
      </div>
    );
  };

export { SkeletonList }